import {AppLayout} from "src/features/client";
import {ProductDetails} from "src/widgets";
import {generateMetaData} from "src/shared/config/seo/meta-data";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";

export default function ProductPage() {
    return (
        <AppLayout>
            <ProductDetails/>
        </AppLayout >
    );
}
